import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { AbstractFeatureEntityState, AbstractFeatureStoreModel, AbstractFeatureUIModel } from '@y42/feature/models';
import { CustomTheme, ThemeData, VisualizationThemeSettings } from '@y42/json-schema';

export class VisualizationThemeSettingsGitModel extends VisualizationThemeSettings {
  constructor(model: VisualizationThemeStoreModel) {
    super();
    const settings = model.settings;
    this.$schema = settings.$schema;
    this.theme = settings.theme;
  }
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}

export class VisualizationThemeStoreModel extends Y42MetadataGitModel implements AbstractFeatureStoreModel {
  constructor(model: VisualizationThemeStoreModel) {
    super(model);
    this.$name = model.$name;
    this.$path = model.$path;
    this.$level = model.$level;
    this.$parentFolders = model.$parentFolders;
    this.settings = model.settings;
  }

  $name: string;
  $path: string;
  $level: number;
  $parentFolders: string[];

  settings: VisualizationThemeSettingsGitModel;
}

export type VisualizationThemeUIModel = AbstractFeatureUIModel &
  Omit<VisualizationThemeStoreModel, 'settings'> &
  VisualizationThemeSettingsGitModel;

export type VisualizationThemeState = AbstractFeatureEntityState<VisualizationThemeStoreModel> & {
  ui: {
    activeSection: VisualizationThemeSection;
    localThemeChanges: Partial<ThemeData>;
  };
};

export type VisualizationThemeSection =
  | 'theme-picker'
  | 'theme-colors'
  | 'frames'
  | 'charts'
  | 'visual-mapping'
  | 'axes'
  | 'legends'
  | 'tooltips'
  | 'line-charts'
  | 'tables'
  | 'cohort-colors';

export type CustomThemeWithId = CustomTheme & { id: string };
